import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { CvSectionProfileSexEnum } from 'gen';
import { RootState } from 'spa_registration_app/store';
import { DATE_SEPARATOR_IN_FORM } from 'src/utils/constants';
import { splitDate } from 'src/utils/date';

export const namespace = 'photo';
const actionCreator = actionCreatorFactory(namespace);

export interface ProfileInfo {
  full_name?: string;
  birthday?: string;
  sex?: CvSectionProfileSexEnum;
  email?: string;
  phone_number?: string;
  location?: string;
  headline?: string;
  website_url?: string;
  profile_image?: File;
}
export interface UserInfo {
  password?: string;
  password_confirmation?: string;
}

export const UpdateProfileInfo = actionCreator<ProfileInfo>(
  'UPDATE_PROFILE_INFO'
);
export const ProfileInfoUpdated = actionCreator<ProfileInfo>(
  'PROFILE_INFO_UPDATED'
);
export const UpdateUserInfo = actionCreator<UserInfo>('UPDATE_USER_INFO');
export const UserInfoUpdated = actionCreator<UserInfo>('USER_INFO_UPDATED');
export const CreateCvWithUser = actionCreator<null>('CREATE_CV_WITH_USER');

export interface State {
  profileInfo: ProfileInfo;
  userInfo: UserInfo;
}

const initialState = (): State => {
  return {
    profileInfo: {
      full_name: null,
      birthday: null,
      sex: CvSectionProfileSexEnum.NotKnown,
      email: null,
      phone_number: null,
      location: null,
      headline: null,
      website_url: null,
      profile_image: null,
    },
    userInfo: {
      password: null,
      password_confirmation: null,
    },
  };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(UpdateProfileInfo, function(context, action) {
      context.commit(ProfileInfoUpdated(action.payload));
    }),
    action(UpdateUserInfo, function(context, action) {
      context.commit(UserInfoUpdated(action.payload));
    }),
    action(CreateCvWithUser, async function(context) {
      const { profileInfo, userInfo } = context.state;
      const {
        full_name,
        birthday,
        sex,
        email,
        phone_number,
        location,
        headline,
        website_url,
        profile_image,
      } = profileInfo;
      const { password, password_confirmation } = userInfo;

      const [birthday_year, birthday_month, birthday_day] = splitDate(
        birthday,
        DATE_SEPARATOR_IN_FORM
      );

      await this.registerApi.createAccountWithCv(
        email || '',
        password,
        password_confirmation,
        1,
        full_name,
        birthday_year || '',
        birthday_month || '',
        birthday_day || '',
        sex || '',
        phone_number || '',
        location || '',
        headline || '',
        website_url || '',
        profile_image
      );
    })
  ),
  mutations: combineMutation(
    mutation(ProfileInfoUpdated, function(state, action) {
      state.profileInfo = action.payload;
    }),
    mutation(UserInfoUpdated, function(state, action) {
      state.userInfo = action.payload;
    })
  ),
  getters: {
    profileInfo: state => state.profileInfo,
    userInfo: state => state.profileInfo,
  },
};
